import React from 'react';
import {Row, Col} from 'react-bootstrap';
import MovieCard from '../movie-card/movie-card.component';
//import LoaderComponent from '../../common/loader.component';

const styles = {
  movieColumn: {
    marginBottom: 20
  }
}

const triggerFnc =() => {
  return (
  console.log("here we go on triggering")
  );
}

const MovieListComponent = ({movies, isLoading}) => {
  
  var movieColumns = 0; 

  if ( movies != null && movies.length < 2) {
    movieColumns = movies ? movies.map(movie => (
      <Col style={styles.movieColumn} key={movie.id} xs={5} sm={5} md={5} lg={5} >
        <MovieCard movie={movie}   />
      </Col>
    )) : null;
  } else {
  movieColumns = movies ? movies.map(movie => (
    <Col style={styles.movieColumn} key={movie.id} xs={3} sm={6} md={4} lg={3} >
      <MovieCard movie={movie}/>
    </Col>
  )) : null;
}
  
  return (
    <Row>
      {movieColumns}
    </Row>
  );
}

export default MovieListComponent;



// WEBPACK FOOTER //
// ./src/modules/movie-browser/movie-list/movie-list.component.js